<div class="box-group-container">
    <mat-checkbox ngDefaultControl class="primary-button" labelPosition="after" [checked]="datasource.selected" [indeterminate]="indeterminate" (change)="onChanged($event)">
        <span class="label">{{ datasource.name }}</span>
    </mat-checkbox>
</div>

@for (box of datasource.boxes; track box.id) {
    <div class="box-container">
        <app-box [datasource]="box" [quiet]="quiet" (selected)="onBoxSelected($event)"></app-box>
    </div>
}
